// extracted by mini-css-extract-plugin
export default {"tagsBg":"tags_tagsBg__NIod-","tagItemShell":"tags_tagItemShell__yH7WR","tagImg":"tags_tagImg__S3m34","tagItem":"tags_tagItem__mELfT"};